import script from "./GroupLevelSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./GroupLevelSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./GroupLevelSidebar.vue?vue&type=style&index=0&id=d87f3bce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d87f3bce"]])

export default __exports__